import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Country } from "../../models/country.model";

@Injectable()
export class CountryProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<Country> {
    return this.http
      .get<Country>(`${this.url}/countries/${id}`)
      .map(response => {
        return new Country(response);
      })
      .catch(this.handleError)
  }

  getAll(): Observable<Country[]> {
    return this.http
      .get<Country[]>(`${this.url}/countries`)
      .map(response => {
        return response.map((country) => new Country(country));
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/country/country.ts